import { useTheme } from '@mui/material';
import { TableV1 } from '../../../components/Table/TableV1';
import {
  ColumnFiltersState,
  SortingState,
  getCoreRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useState } from 'react';
import { useClosedTSTableColumns } from '../hooks/useClosedTSTableColumns';
import { useClosedLogsMapped } from '../hooks/useAllOPLogsMapped';
import { User } from '../../../types';
import { TableSkeletonLoader } from '../../../components/SkeletonLoader/Table.SkeletonLoader';
import { ClosedTimesheetsFilterSection } from './ClosedTimesheetsFilterSection';

interface AllOpenTimesheetsTableProps {
  operatingPartners: User[];
  timesheetsLoading: boolean;
}

export const ClosedTimesheetApprovalsTable = ({
  operatingPartners,
  timesheetsLoading,
}: AllOpenTimesheetsTableProps) => {
  const { colors } = useTheme();

  const [sorting, setSorting] = useState<SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const allOPLogs = useClosedLogsMapped(operatingPartners);
  const columns = useClosedTSTableColumns();

  const table = useReactTable({
    data: allOPLogs ?? [],
    columns,
    state: {
      sorting,
      columnFilters,
    },
    enableRowSelection: true,
    enableSorting: true,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  });

  return (
    <>
      {timesheetsLoading ? (
        <TableSkeletonLoader />
      ) : (
        <>
          <ClosedTimesheetsFilterSection operatingPartners={operatingPartners} table={table} />
          <TableV1
            table={table}
            height='auto'
            isLastColumnSticky={false}
            wrapperStyle={{
              maxHeight: 'calc(100vh - 320px)',
              overflowX: 'scroll',
              border: `1px solid ${colors.border.default}`,
            }}
          />
        </>
      )}
    </>
  );
};
